<p class="modal-title">More information required</p>
<div class="modal-close" (click)="onClose()">
    <img alt="Close" src="../../../assets/icons/circle-x.svg" />
</div>
<p>Enter health costs for your Dependents on the next screen to view annual cost projections for your household.</p>